module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyAgMAAADXW5YtAAAADFBMVEUAh1Gq18X///+p18Sq7mSIAAAAG0lEQVR4AWOAAalVELAGJjDyZEZlRmVGZUZlAA5EDyjCFKrBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ng.png
// module id = Uq8R
// module chunks = 0